import { render } from "./ItemPrecioLicencia.vue?vue&type=template&id=2b9bc5e7&scoped=true"
import script from "./ItemPrecioLicencia.vue?vue&type=script&lang=js"
export * from "./ItemPrecioLicencia.vue?vue&type=script&lang=js"

import "./ItemPrecioLicencia.vue?vue&type=style&index=0&id=2b9bc5e7&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9bc5e7"]])

export default __exports__